// extracted by mini-css-extract-plugin
export default {"content":"styles_content__nuwt0","title":"styles_title__gCQSH","desc":"styles_desc__77S0e"};